var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C10.4477 2 10 2.44772 10 3V4.22302C5.99202 5.13247 3 8.71683 3 13C3 17.9706 7.02944 22 12 22C16.9706 22 21 17.9706 21 13C21 10.314 19.8234 7.90284 17.9574 6.25381L18.5857 5.46852C18.8444 5.14507 18.792 4.67311 18.4685 4.41435C18.1451 4.15559 17.6731 4.20803 17.4143 4.53148L16.7542 5.35671C15.9179 4.83547 14.99 4.44765 14 4.22302V3C14 2.44772 13.5523 2 13 2H11ZM12.75 8V12.618L15.537 15.4764C15.8262 15.773 15.8202 16.2478 15.5236 16.537C15.227 16.8262 14.7522 16.8202 14.463 16.5236L11.463 13.4467C11.3264 13.3066 11.25 13.1187 11.25 12.9231V8C11.25 7.58579 11.5858 7.25 12 7.25C12.4142 7.25 12.75 7.58579 12.75 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.b7fc24ebbb4786fe75ce36b5415cf79c.svg";
export { ForwardRef as ReactComponent };